export const Colors = {
  tealcTransparent: "#009ca666",
  tealc: "#009ca6 ",
  tealcDark: "#7f7f7f",
  turqouise: "#4dbecd",
  roastedYellow: "#e1d4ac",
  champagne: "#ece1c6",
  dirtyWhite: "#F4F6F7 ",
  darkGrey: "#3b3b3b"
}